var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 31,
    viewBox: "0 0 46 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8466 30.1087C26.4508 30.1087 21.266 23.5925 21.266 15.5543C21.266 7.5162 26.4508 1 32.8466 1C39.2423 1 44.4271 7.5162 44.4271 15.5543C44.4271 23.5925 39.2423 30.1087 32.8466 30.1087Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.6736,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5806 30.1087C6.18483 30.1087 1.00004 23.5925 1.00004 15.5543C1.00004 7.5162 6.18483 1 12.5806 1C18.9763 1 24.1611 7.5162 24.1611 15.5543C24.1611 23.5925 18.9763 30.1087 12.5806 30.1087Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.6736,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4497 27.1978C13.743 27.1978 10.7382 21.9848 10.7382 15.5543C10.7382 9.12381 13.743 3.91086 17.4497 3.91086C21.1563 3.91086 24.1611 9.12381 24.1611 15.5543C24.1611 21.9848 21.1563 27.1978 17.4497 27.1978Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6628 27.1978C32.9562 27.1978 29.9514 21.9848 29.9514 15.5543C29.9514 9.12381 32.9562 3.91086 36.6628 3.91086C40.3694 3.91086 43.3743 9.12381 43.3743 15.5543C43.3743 21.9848 40.3694 27.1978 36.6628 27.1978Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.ca907b24af6ea7701491f3566b73f5c9.svg";
export { ForwardRef as ReactComponent };